import { Checkbox, FormControlLabel, Grid, Paper } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';

export default function SrlNonTrasparente(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeImposteContributi";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();
    //let readOnlyQuote: boolean = false;

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;
        console.log('name', name)
        if (name === "F208_artigiano" && checked === true && (state.imposteContributi.F209_commerciante === true || state.imposteContributi.F210_NOIVS === true)) {
            state.imposteContributi.F209_commerciante = false;
            state.imposteContributi.F210_NOIVS = false;
        } else if (name === "F209_commerciante" && checked === true && (state.imposteContributi.F208_artigiano === true || state.imposteContributi.F210_NOIVS === true)) {
            state.imposteContributi.F208_artigiano = false
            state.imposteContributi.F210_NOIVS = false;
        } else if (name === "F210_NOIVS" && checked === true && (state.imposteContributi.F209_commerciante === true || state.imposteContributi.F208_artigiano === true)) {
            state.imposteContributi.F209_commerciante = false;
            state.imposteContributi.F208_artigiano = false
            disableFieldQuote();
        }
        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global,name,checked,action,true);
    };

    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }

    const disableFieldQuote = () => {
        state.imposteContributi.F211_quota1socio = 0;
        state.imposteContributi.F212_quota2socio = 0;
        state.imposteContributi.F213_quota3socio = 0;
        state.imposteContributi.F214_quota4socio = 0;
        state.imposteContributi.F215_quota5socio = 0;
    }

    return (
        <Paper className={gClasses.fullWidthPaper}>
            <Grid container>
                <SectionSubTitle text="Tipologia"></SectionSubTitle>
                <Grid container>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F208_artigiano}
                                name='F208_artigiano'
                                id='F208_artigiano'
                                value={state.imposteContributi.F208_artigiano}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Artigiano"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F209_commerciante}
                                name='F209_commerciante'
                                id='F209_commerciante'
                                value={state.imposteContributi.F209_commerciante}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Commerciante"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F210_NOIVS}
                                name='F210_NOIVS'
                                id='F210_NOIVS'
                                value={state.imposteContributi.F210_NOIVS}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="NO IVS"
                    />
                </Grid>
            </Grid>
            <div>
                <SectionSubTitle text="Dati soci per contributi IVS"></SectionSubTitle>
                <NumberField
                    name="F211_quota1socio"
                    label="Quota % 1° socio"
                    value={state.imposteContributi.F211_quota1socio}
                    className={state.imposteContributi.F210_NOIVS === true ? gClasses.textFieldReadOnly : gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    symbol="%"
                    readOnly={state.imposteContributi.F210_NOIVS}
                />
                <NumberField
                    name="F212_quota2socio"
                    label="Quota % 2° socio"
                    value={state.imposteContributi.F212_quota2socio}
                    className={state.imposteContributi.F210_NOIVS === true ? gClasses.textFieldReadOnly : gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    symbol="%"
                    readOnly={state.imposteContributi.F210_NOIVS}
                />
                <NumberField
                    name="F213_quota3socio"
                    label="Quota % 3° socio"
                    value={state.imposteContributi.F213_quota3socio}
                    className={state.imposteContributi.F210_NOIVS === true ? gClasses.textFieldReadOnly : gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    symbol="%"
                    readOnly={state.imposteContributi.F210_NOIVS}
                />
                <NumberField
                    name="F214_quota4socio"
                    label="Quota % 4° socio"
                    value={state.imposteContributi.F214_quota4socio}
                    className={state.imposteContributi.F210_NOIVS === true ? gClasses.textFieldReadOnly : gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    symbol="%"
                    readOnly={state.imposteContributi.F210_NOIVS}
                />
                <NumberField
                    name="F215_quota5socio"
                    label="Quota % 5° socio"
                    value={state.imposteContributi.F215_quota5socio}
                    className={state.imposteContributi.F210_NOIVS === true ? gClasses.textFieldReadOnly : gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    symbol="%"
                    readOnly={state.imposteContributi.F210_NOIVS}
                />
                <NumberField
                    name="J214_aliquota_ires"
                    label="Aliquota Ires"
                    value={state.imposteContributi.J214_aliquota_ires}
                    className={gClasses.textField}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    symbol={"%"}
                />
            </div>
        </Paper>
    )
}